<template>
  <div class="loader-container">
    <div class="level4-category-item">
      <a
        href="#"
        @click.prevent="$emit('categorySelect', { id: category.Id, name: category.Name })"
        class="category-item"
      >
        <div v-if="category.PictureId" class="category-item__img">
          <img :src="pictureUrlPath(category.ImageUrl)" />
        </div>
        <SfHeading
          class="category-item__title"
          :title="category.Name"
          :level="4"
        />
      </a>
    </div>
  </div>
</template>

<script>
import { SfHeading } from '@storefront-ui/vue';
import { config } from '@/modules/core';

export default {
  name: 'Level4CategoryMenuItem',
  components: {
    SfHeading,
  },
  mixins: [config],
  props: {
    category: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";

.level4-category-item {
  max-width: 216px;
  padding: var(--spacer-xs);
  margin: 0 auto var(--spacer-base) auto;
  position: relative;
  @include flexbox-desktop {
    opacity: 0.9;
    &:hover {
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
        0 6px 20px 0 rgba(0, 0, 0, 0.19);
      opacity: 1;
    }
  }
}

.category-item {
  @include font(
    --product-card-title-font,
    var(--font-medium),
    var(--font-sm),
    1.2,
    var(--font-family-secondary)
  );
  text-decoration: none;
  &__img img {
    width: 100%;
  }
  &__content-id {
    position: absolute;
    top: var(--spacer-2xs);
    right: var(--spacer-2xs);
    padding: var(--spacer-xs);
    border: 1px solid var(--_c-blue-primary);
    color: var(--c-dark);
  }
  &__title {
    color: var(--c-dark);
    margin: var(--spacer-sm) 0;
  }
}
</style>
